









export default {
  name: 'QuestionMarkIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
